import { Injectable } from '@angular/core'
import { lastValueFrom, Subject } from 'rxjs'
import { InvitationsApiService } from 'src/api/invitations-api/invitations-api.service'
import { AuthService } from '../isbeauth/auth.service'
import { NavMenueItem, NotificationFile, NotificationItem } from './nav-menu.interface'
import moment from 'moment'
import { navMenuListUra } from './nav-menu-list'
import { Router } from '@angular/router'
import { ShimuraGarageMigrationsService } from 'src/api/micomel-migrations-api/micomel-migrations-api.service'
import { NotificationApiService } from 'src/api/notification-api/notices-api.service'
import { Wbs } from 'src/api/petabo-api/petabo-api.interface'
import { PetaboApiService } from 'src/api/petabo-api/petabo-api.service'
import { forEach } from 'jszip'
import { IndexCoreMyideaApiService } from 'src/api/indexcore-myidea-api/indexcore-myidea-api.service'
export interface ImportantNoticeSetting {
  notificationDivision: string
  buttonTitle: string
  buttonText: string
  showPopupOnTopPage: boolean
  popup: {
    title: string
    content: string
    listItems: string[]
    linkText: string
    closeButtonText: string
  }
  linkUrl: string
  actionTransactionKey: string
  endDatetime: string
}

@Injectable({
  providedIn: 'root'
})
export class NavService {
  constructor(
    private invitationsApiService: InvitationsApiService,
    private indexCoreMyideaApiService: IndexCoreMyideaApiService,
    private authService: AuthService,
    private router: Router,
    private micomelMigrationsService: ShimuraGarageMigrationsService,
    private petaboApiService: PetaboApiService
  ) {}

  private personalNotificationList: NotificationItem[] = []
  private personalNotificationListInfo = new Subject<NotificationItem[]>()
  public personalNotificationListInfoSource$ = this.personalNotificationListInfo.asObservable()
  public get getPersonalAlertAction(): NotificationItem[] {
    return this.personalNotificationList
  }

  private importantNotice: ImportantNoticeSetting = undefined
  private importantNoticeInfo = new Subject<ImportantNoticeSetting>()
  public importantNoticeInfoSource$ = this.importantNoticeInfo.asObservable()
  public get getImportantNoticeAction(): ImportantNoticeSetting {
    return this.importantNotice
  }

  public updatenotificationList(): void {
    this.updatePersonalNotificationList()
    this.updateImportantNotice()
  }
  public updatePersonalNotificationList(): void {
    this.personalNotificationList = []

    const promise1 = new Promise(async (resolve) => {
      const ret = await this.getInvitationSendList()
      if (ret.length) {
        this.personalNotificationList.push(...ret)
      }
      resolve(ret)
    })

    Promise.all([promise1]).then(async () => {
      this.personalNotificationListInfo.next(this.personalNotificationList)
    })
  }

  // 招待送信件数取得
  async getInvitationSendList(): Promise<NotificationItem[]> {
    const customerCd = this.authService.AccountInfo?.customerCd
    if (!customerCd) {
      return []
    }
    const ret = await this.invitationsApiService.getInvitationCountList(customerCd)

    if (!ret?.data) {
      return []
    }
    const list: NotificationItem[] = []

    const invitationSendCount = ret.data.send
    if (invitationSendCount !== 0) {
      const message: NotificationItem = {
        title: '相手が未回答の招待が',
        count: invitationSendCount,
        link: '/invitation-send-list'
      }
      list.push(message)
    }

    const invitationReceiveCount = ret.data.receive
    if (invitationReceiveCount !== 0) {
      const message: NotificationItem = {
        title: '未承認の招待が',
        count: invitationReceiveCount,
        link: '/invitation-receive-list'
      }
      list.push(message)
    }
    return list
  }

  // 重要なお知らせ取得
  public async updateImportantNotice(): Promise<void> {
    this.importantNotice = undefined
    const ret = await this.getImportantNoticeJson()

    let enableData = null

    // endDatetimeをチェック
    const now = new Date()
    if (ret?.endDatetime) {
      const endDate = new Date(ret.endDatetime)
      if (now <= endDate) {
        enableData = ret
      }
    } else {
      // endDatetimeが設定されていない場合は表示
      enableData = ret
    }

    this.importantNotice = enableData
    this.importantNoticeInfo.next(this.importantNotice)
  }

  // 重要なお知らせ取得
  async getImportantNoticeJson(): Promise<ImportantNoticeSetting> {
    try {
      const data = await this.indexCoreMyideaApiService.getModel('notification/importantNotice.json')
      return data
    } catch {
      return null
    }
  }

  async saveImportantNoticeJson(payload: ImportantNoticeSetting): Promise<boolean> {
    try {
      await this.indexCoreMyideaApiService.postModel('notification/importantNotice.json', payload)

      this.importantNotice = payload
      this.importantNoticeInfo.next(this.importantNotice)
      return true
    } catch {
      return false
    }
  }

  uraMenuList(): NavMenueItem[] {
    navMenuListUra.forEach((parent) => {
      parent.children.forEach((child) => {
        child.disabled = !this.authService.checkAuthorityForView(child.path)
      })
      parent.disabled = true
      if (parent.children.length) {
        const firstChild = parent.children.find((x) => !x.disabled)
        if (firstChild) {
          parent.disabled = false
          parent.path = firstChild.path
        } else {
          parent.disabled = true
          parent.path = null
        }
      } else {
        parent.disabled = false
      }
    })
    return navMenuListUra
  }
}
